import axios from "axios";
import store from "../store/index";
import axiosUrl from "./axios.service";
const API_URL = axiosUrl.getAxiosUrl();

class AIService {
  async getAISettings() {
    return await axios
      .get(API_URL + `aisettings/getAISettings`)
      .then(response => {
        store.commit("aiSettings/setSettings", response.data);
      })
      .catch(error => {
        if (error) {
          store.commit("aiSettings/updateModalError", error.response.data),
            store.commit("aiSettings/enableModalError");
        }
      });
  }

  async updateAISettings(settings) {
    return await axios
      .post(API_URL + `aisettings/updateSettings`, {
        introTextDutch: settings.introTextDutch,
        introTextGerman: settings.introTextGerman,
        helpTextDutch: settings.helpTextDutch,
        helpTextGerman: settings.helpTextGerman,
        globalRateLimiting: settings.globalRateLimiting
      })
      .catch(error => {
        if (error) {
          store.commit("aiSettings/updateModalError", error.response.data),
            store.commit("aiSettings/enableModalError");
        }
      });
  }

  async getMessagesByConversation(conversationId) {
    return await axios
      .get(API_URL + "aiAssistantLogs/getMessagesFromConversation", {
        params: {
          conversationId: conversationId
        }
      })
      .then(response => {
        store.commit(
          "aiAssistantLogs/setMessagesFromSelectedConversation",
          response.data
        );
      })
      .catch(error => {
        if (error) {
          store.commit("aiSettings/updateModalError", error.response.data),
            store.commit("aiSettings/enableModalError");
        }
      });
  }

  async exportModerationLogs() {
    return await axios.get(API_URL + "aiAssistantLogs/exportModerationLogs", {
      responseType: "blob"
    });
  }

  async exportAnalyticsLogs() {
    return await axios.get(API_URL + "aiAssistantLogs/exportAnalyticsLogs", {
      responseType: "blob"
    });
  }

  async exportRateLimitLogs() {
    return await axios.get(API_URL + "aiAssistantLogs/exportRateLimitLogs", {
      responseType: "blob"
    });
  }

  async getAICustomers() {
    return await axios
      .get(API_URL + "customers/getAICustomersList")
      .then(response => {
        store.commit("customers/updateAICustomersList", response.data);
      })
      .catch(error => {
        if (error) {
          store.commit("aiSettings/updateModalError", error.response.data),
            store.commit("aiSettings/enableModalError");
        }
      });
  }

  async getAIUsers() {
    return await axios
      .get(API_URL + "users/getAIUsersList")
      .then(response => {
        store.commit("user/updateAIUsersList", response.data);
      })
      .catch(error => {
        if (error) {
          store.commit("aiSettings/updateModalError", error.response.data),
            store.commit("aiSettings/enableModalError");
        }
      });
  }
}

export default new AIService();
